jQuery('.nws-testimonial-slide').slick({
  dots: true,
  arrows: true,
  infinite: true,
  slidesToShow: 3,
  centerMode: true,
  centerPadding: '0px',
  focusOnSelect: true,
  autoplay: false,
  autoplaySpeed: 3000,
  slidesToScroll: 1,
  prevArrow: `
    <button type="button" class="slick-prev">
      <svg xmlns="http://www.w3.org/2000/svg" width="49" height="16" viewBox="0 0 49 16" fill="none">
        <path d="M0.292892 8.70711C-0.0976295 8.31658 -0.0976295 7.68342 0.292892 7.29289L6.65686 0.928932C7.04738 0.538408 7.68055 0.538408 8.07107 0.928932C8.46159 1.31946 8.46159 1.95262 8.07107 2.34315L2.41422 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68055 15.4616 7.04738 15.4616 6.65686 15.0711L0.292892 8.70711ZM49 9H1V7H49V9Z" fill="white"/>
      </svg>
    </button>`,
  nextArrow: `
    <button type="button" class="slick-next">
      <svg xmlns="http://www.w3.org/2000/svg" width="49" height="16" viewBox="0 0 49 16" fill="none">
        <path d="M48.7071 8.70711C49.0976 8.31658 49.0976 7.68342 48.7071 7.29289L42.3431 0.928932C41.9526 0.538408 41.3195 0.538408 40.9289 0.928932C40.5384 1.31946 40.5384 1.95262 40.9289 2.34315L46.5858 8L40.9289 13.6569C40.5384 14.0474 40.5384 14.6805 40.9289 15.0711C41.3195 15.4616 41.9526 15.4616 42.3431 15.0711L48.7071 8.70711ZM0 9H48V7H0V9Z" fill="white"/>
      </svg>
    </button>`,
  responsive: [{
    breakpoint: 1025,
    settings: {
      dots: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      centerMode: true,
      centerPadding: '20px'
    }
  }, {
    breakpoint: 769,
    settings: {
      dots: true,
      slidesToShow: 2,
      slidesToScroll: 1
    }
  },{
    breakpoint: 621,
    settings: {
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
});

// for add to cart btn
jQuery(".nws-atc-btn-frm").each(function () {
  jQuery(this).bind("submit", function (e) {
    e.preventDefault();
    var formID = jQuery(this).attr("id");
      jQuery.ajax({
        type: 'post',
        url: '/cart/add.js',
        data: jQuery(this).serialize(),
        dataType: 'json',
        success: function (resp) {
        Shopify.KT_getCart();
        KT.drawOpen();
        //console.log(success);
        },
        error: function (error) {
        //console.log(error)
      }
      });
    return false;
  });
});

jQuery(".nws-variant-box").click(function(){
var id = jQuery(this).attr("data-id");
jQuery("#"+id+" .nws-variant-box").removeClass('nws-active');
jQuery(this).addClass('nws-active');
});

// for iframe

$(document).ready(function() {
if (window.matchMedia("(max-width: 768px)").matches) {
    $('.nws-about .about-content .about-body iframe').parent().css({
        'margin-bottom': '25px',
        'aspect-ratio': '16 / 9'
    });
    $('.nws-about .about-content .about-body img').parent().css({
        'display': 'block',
        'width': '100%',
        // 'max-width': '480px',
    });
}
$('.nws-about .about-content .about-body iframe').parent().css({
    'max-width': 'fit-content',
    'margin': '0 auto 25px',
});
    // $('.nws-about .about-content .about-body iframe').css({
    //     'position': 'absolute',
    //     'top': '0',
    //     'left': '0',
    //     'width': '100%',
    //     'height': '100%',
    //     'border': '0'
    // });
});

jQuery('.pdp-slide').slick({
  dots: true,
  arrows: true,
  infinite: false,
  slidesToShow: 2,
  autoplay: false,
  autoplaySpeed: 3000,
  focusOnSelect: false,
  accessibility: false,
  pauseOnHover: false,
  slidesToScroll: 1,
  prevArrow: `
    <button type="button" class="slick-prev">
      <svg xmlns="http://www.w3.org/2000/svg" width="49" height="16" viewBox="0 0 49 16" fill="none">
        <path d="M0.292892 8.70711C-0.0976295 8.31658 -0.0976295 7.68342 0.292892 7.29289L6.65686 0.928932C7.04738 0.538408 7.68055 0.538408 8.07107 0.928932C8.46159 1.31946 8.46159 1.95262 8.07107 2.34315L2.41422 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68055 15.4616 7.04738 15.4616 6.65686 15.0711L0.292892 8.70711ZM49 9H1V7H49V9Z" fill="white"/>
      </svg>
    </button>`,
  nextArrow: `
    <button type="button" class="slick-next">
      <svg xmlns="http://www.w3.org/2000/svg" width="49" height="16" viewBox="0 0 49 16" fill="none">
        <path d="M48.7071 8.70711C49.0976 8.31658 49.0976 7.68342 48.7071 7.29289L42.3431 0.928932C41.9526 0.538408 41.3195 0.538408 40.9289 0.928932C40.5384 1.31946 40.5384 1.95262 40.9289 2.34315L46.5858 8L40.9289 13.6569C40.5384 14.0474 40.5384 14.6805 40.9289 15.0711C41.3195 15.4616 41.9526 15.4616 42.3431 15.0711L48.7071 8.70711ZM0 9H48V7H0V9Z" fill="white"/>
      </svg>
    </button>`,
  responsive: [
    {
    breakpoint: 1200,
    settings: {
      dots: true,
      slidesToShow: 2,
      slidesToScroll: 1,
    }
  },
    {
    breakpoint: 1025,
    settings: {
      dots: true,
      slidesToShow: 2,
      slidesToScroll: 1,
    }
  }, {
    breakpoint: 769,
    settings: {
      dots: true,
      arrows: false,
      slidesToShow: 2,
      slidesToScroll: 1
    }
  },{
    breakpoint: 621,
    settings: {
      dots: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
});
jQuery('.best-seller-slide').slick({
  dots: true,
  arrows: true,
  infinite: false,
  slidesToShow: 4,
  autoplay: false,
  autoplaySpeed: 3000,
  focusOnSelect: false,
  accessibility: false,
  pauseOnHover: false,
  slidesToScroll: 1,
  prevArrow: `
    <button type="button" class="slick-prev">
      <svg xmlns="http://www.w3.org/2000/svg" width="49" height="16" viewBox="0 0 49 16" fill="none">
        <path d="M0.292892 8.70711C-0.0976295 8.31658 -0.0976295 7.68342 0.292892 7.29289L6.65686 0.928932C7.04738 0.538408 7.68055 0.538408 8.07107 0.928932C8.46159 1.31946 8.46159 1.95262 8.07107 2.34315L2.41422 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68055 15.4616 7.04738 15.4616 6.65686 15.0711L0.292892 8.70711ZM49 9H1V7H49V9Z" fill="white"/>
      </svg>
    </button>`,
  nextArrow: `
    <button type="button" class="slick-next">
      <svg xmlns="http://www.w3.org/2000/svg" width="49" height="16" viewBox="0 0 49 16" fill="none">
        <path d="M48.7071 8.70711C49.0976 8.31658 49.0976 7.68342 48.7071 7.29289L42.3431 0.928932C41.9526 0.538408 41.3195 0.538408 40.9289 0.928932C40.5384 1.31946 40.5384 1.95262 40.9289 2.34315L46.5858 8L40.9289 13.6569C40.5384 14.0474 40.5384 14.6805 40.9289 15.0711C41.3195 15.4616 41.9526 15.4616 42.3431 15.0711L48.7071 8.70711ZM0 9H48V7H0V9Z" fill="white"/>
      </svg>
    </button>`,
  responsive: [
     {
    breakpoint: 1366,
    settings: {
      dots: true,
      arrows: false,
      slidesToShow: 3,
      slidesToScroll: 1
    }
  },
     {
    breakpoint: 769,
    settings: {
      dots: true,
      arrows: false,
      slidesToShow: 2,
      slidesToScroll: 1
    }
  },
    {
    breakpoint: 621,
    settings: {
      dots: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
});

document.addEventListener('DOMContentLoaded', function() {
  var modal = document.getElementById('video-popup');
  var buttons = document.querySelectorAll('.open-video-popup'); // Select all buttons
  var closeBtn = document.getElementsByClassName('close')[0];
  var video = document.getElementById('popup-video');

  buttons.forEach(function(btn) { // Loop through all buttons
    btn.addEventListener('click', function() {
      modal.style.display = 'block';
      video.play();
    });
  });

  closeBtn.onclick = function() {
    modal.style.display = 'none';
    video.pause();
    video.currentTime = 0;
  }

  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = 'none';
      video.pause();
      video.currentTime = 0;
    }
  }
});



document.addEventListener('DOMContentLoaded', function() {
  var modal = document.getElementById('video-popup-1');
  var btn = document.getElementById('open-video-popup-1');
  var span = document.getElementsByClassName('closes')[0];
  var video = document.getElementById('popup-video-1');

  btn.onclick = function() {
    modal.style.display = 'block';
    video.play();
  }

  span.onclick = function() {
    modal.style.display = 'none';
    video.pause();
    video.currentTime = 0;
  }

  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = 'none';
      video.pause();
      video.currentTime = 0;
    }
  }
});

  document.addEventListener('DOMContentLoaded', function() {
    var modal = document.getElementById('video-popup-2');
    var btn = document.getElementById('open-video-popup-2');
    var span = document.getElementsByClassName('closed')[0];
    var video = document.getElementById('popup-video-2');
    var iframe = document.getElementById('popup-iframe');

    // Function to get YouTube player API
    function stopYouTubeVideo() {
      iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }

    btn.onclick = function() {
      modal.style.display = 'block';

      // Check if it's a YouTube iframe
      if (iframe) {
        var src = iframe.src;
        if (src.indexOf('autoplay=1') === -1) {
          iframe.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
        }
      } else if (video) {
        video.play();
      }
    }

    span.onclick = function() {
      modal.style.display = 'none';

      if (iframe) {
        stopYouTubeVideo();
      } else if (video) {
        video.pause();
        video.currentTime = 0;
      }
    }

    window.onclick = function(event) {
      if (event.target == modal) {
        modal.style.display = 'none';

        if (iframe) {
          stopYouTubeVideo();
        } else if (video) {
          video.pause();
          video.currentTime = 0;
        }
      }
    }
  });


  // jQuery('.slide-hero-prod').slick({
  //     dots: false,
  //     arrows: false,
  //     infinite: true,
  //     fade: true,
  //     adaptiveHeight: false,
  //     slidesToShow: 1,
  //     autoplaySpeed: 1500,
  //     speed: 1000,
  //     focusOnSelect: false,
  //     pauseOnHover:false,
  //     autoplay: true,
  //     slidesToScroll: 1
  // }); 



  $('.slide-hero-prod').on('init', function(event, slick){
    // Show all slides once slick is initialized
    $('.slide-hero-img').css('display', 'block');
  });

  // Initialize slick slider
  $('.slide-hero-prod').slick({
    dots: false,
      arrows: false,
      infinite: true,
      fade: true,
      adaptiveHeight: false,
      slidesToShow: 1,
      autoplaySpeed: 1500,
      speed: 1000,
      focusOnSelect: false,
      pauseOnHover:false,
      autoplay: true,
      slidesToScroll: 1
  });



// $(document).ready(function() {
//     // Hide all slides initially except the first one
//     $('.slide-hero-prod .slide-hero-img').hide().first().show();

//     // Initialize slick after the page has fully loaded
//     $(window).on('load', function() {
//         $('.slide-hero-prod').slick({
//             dots: false,
//             arrows: false,
//             infinite: true,
//             fade: true,
//             adaptiveHeight: false,
//             slidesToShow: 1,
//             autoplaySpeed: 1500,
//             speed: 1000,
//             focusOnSelect: false,
//             pauseOnHover: false,
//             autoplay: true,
//             slidesToScroll: 1
//         });
//     });
// });

 jQuery(window).on("scroll", function() {
    if (jQuery(window).scrollTop() > 140) {
        jQuery("header.custom-header").addClass("fix_top");
        jQuery("section.header-top").addClass("fix_top");
    } else {
        // Remove the background property so it becomes transparent again (defined in your CSS)
        jQuery("header.custom-header").removeClass("fix_top");
        jQuery("section.header-top").removeClass("fix_top");
    }
});
// product card variant selection 
$(document).ready(function () {
    $('.nws-variant-select').on('change', function () {
        var card = $(this).closest('.prd-box');
        var selectedOption = $(this).find(':selected');
        var dataId = selectedOption.data('id');
        card.find('.nws-hidden-input').val(dataId);
        var $prdBox = $(this).closest('.prd-box');
        var dataId = $(this).find(':selected').data('id');
        var $buyBtn = $prdBox.find('.buy-btn');
        var currentHref = $buyBtn.attr('href');
        var newHref = currentHref.replace(/\/cart\/\d+:1/, `/cart/${dataId}:1`);
        $buyBtn.attr('href', newHref);
    });
});

jQuery(window).on("scroll", function() { 
    if(jQuery(window).scrollTop() > 160) {
        jQuery(".template-product").addClass("footer_cart");
    } else {
    //remove the background property so it comes transparent again (defined in your css)
    jQuery(".template-product").removeClass("footer_cart");
 }
});



